// resizeObserverFix.ts
const OriginalResizeObserver = window.ResizeObserver;

window.ResizeObserver = class extends OriginalResizeObserver {
  constructor(callback: ResizeObserverCallback) {
    super((entries, observer) => {
      window.requestAnimationFrame(() => {
        try {
          callback(entries, observer);
        } catch {
          // eslint-disable-next-line no-console
          console.error(
            "prevents:: `loop completed with undelivered notifications`"
          );
          // no-op: prevents "loop completed with undelivered notifications"
        }
      });
    });
  }
};

export {};
